/* ============================================================
   Agrupar fotos de producto por variante (color) en el PDP.

   El color de cada foto se resuelve server-side (SKU de la variante
   que aparece en el nombre del archivo) y se escribe en
   data-media-group-color en cada slide y miniatura.

   - data-group-media="true" + data-initial-color en el contenedor.
   - [data-variant-color-map] = JSON { variantId: colorHandle }.
   - Fotos sin color (token que no coincide con ningún SKU) quedan
     siempre visibles (fallback).

   Desktop (grid, sin Flickity): se ocultan por CSS (.is-group-hidden).
   Mobile/tablet (carrusel Flickity): se QUITAN del carrusel las celdas
   de otros colores, usando window.theme.Flickity.

   IMPORTANTE (fix producción): la galería Flickity usa imagesLoaded, así
   que en vivo (imágenes del CDN) inicializa MÁS TARDE que en el dev. En vez
   de reintentos con tiempo fijo, observamos la clase `flickity-enabled` y
   re-sincronizamos cuando el carrusel realmente se activa/destruye, sin
   importar cuánto tarde. Así funciona igual en preview y en producción.
   ============================================================ */
(function () {
  var HIDDEN = 'is-group-hidden';
  var ENABLED = 'flickity-enabled';

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function flickityOf(el) {
    try {
      var F = window.theme && window.theme.Flickity;
      if (el && F && typeof F.data === 'function') return F.data(el);
    } catch (e) {}
    return null;
  }

  function isEnabled(el) {
    return !!(el && el.classList && el.classList.contains(ENABLED));
  }

  // Fija el scroll vertical durante `ms` para anular el auto-scroll del theme
  // hacia la foto de la variante (solo desktop grid). Se suelta apenas el
  // usuario intenta hacer scroll, para no "frenarlo".
  function lockScroll(ms) {
    var y = window.scrollY || window.pageYOffset || 0;
    var until = Date.now() + (ms || 800);
    var events = ['wheel', 'touchstart', 'touchmove', 'keydown', 'pointerdown', 'mousedown'];
    var opts = { passive: true, capture: true };
    var released = false;
    function release() {
      if (released) return;
      released = true;
      events.forEach(function (ev) { window.removeEventListener(ev, release, opts); });
    }
    events.forEach(function (ev) { window.addEventListener(ev, release, opts); });
    function tick() {
      if (released || Date.now() > until) { release(); return; }
      var cur = window.scrollY || window.pageYOffset || 0;
      if (cur !== y) window.scrollTo(0, y);
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initGallery(root) {
    if (root.dataset.groupMediaReady) return;
    root.dataset.groupMediaReady = '1';

    var colorMap = {};
    var mapEl = root.querySelector('[data-variant-color-map]');
    if (mapEl) {
      try { colorMap = JSON.parse(mapEl.textContent); } catch (e) { colorMap = {}; }
    }

    var slider = root.querySelector('.product-gallery__media-slider');
    var thumbsWrap = root.querySelector('.product-single__thumbnails');

    // Listas maestras (orden original), capturadas ANTES de quitar celdas.
    var mainMaster = toArray(root.querySelectorAll('.product-gallery__media-slide[data-media-group-color]'));
    var navMaster = thumbsWrap
      ? toArray(thumbsWrap.querySelectorAll('.product-single__thumbnail[data-media-group-color]'))
      : [];

    var currentColor = root.getAttribute('data-initial-color') || '';

    function hasColor(color) {
      for (var i = 0; i < mainMaster.length; i++) {
        if (mainMaster[i].getAttribute('data-media-group-color') === color) return true;
      }
      return false;
    }

    function keepFn(color, has) {
      return function (el) {
        var c = el.getAttribute('data-media-group-color');
        if (!color || !has) return true;          // fallback: mostrar todas
        return !c || c === color;                  // color seleccionado + sin color
      };
    }

    // Carrusel (Flickity activo): quita/reinserta celdas para dejar solo el
    // color. Devuelve true si había instancia (se manejó como carrusel).
    function filterFlickity(containerEl, master, keep) {
      var flkty = flickityOf(containerEl);
      if (!flkty) return false;
      // En el carrusel las celdas se quitan del DOM: no dejar CSS oculto.
      master.forEach(function (el) { el.classList.remove(HIDDEN); });
      var target = master.filter(keep);
      try {
        var current = flkty.getCellElements ? flkty.getCellElements() : [];
        var toRemove = current.filter(function (el) { return target.indexOf(el) === -1; });
        if (toRemove.length) flkty.remove(toRemove);
        target.forEach(function (el, i) {
          var have = flkty.getCellElements();
          if (have.indexOf(el) === -1) {
            try { flkty.insert(el, i); } catch (e) { flkty.append(el); }
          }
        });
        // reloadCells re-mide las celdas desde cero. Sin esto, tras insert()
        // Flickity (percentPosition) deja ~15px de más por celda -> gap entre
        // miniaturas al cambiar de color. Con reloadCells la medición coincide
        // con la entrada directa (celdas pegadas).
        if (typeof flkty.reloadCells === 'function') flkty.reloadCells();
        flkty.resize();
        flkty.select(0, false, true);
      } catch (e) {}
      return true;
    }

    // Reatacha al contenedor (en orden original) las celdas que Flickity haya
    // podido quitar del DOM, para el modo grid. Necesario al cruzar de carrusel
    // (mobile) a grid (desktop): las celdas removidas deben volver.
    function ensureAttached(containerEl, master) {
      if (!containerEl) return;
      for (var i = 0; i < master.length; i++) {
        containerEl.appendChild(master[i]); // mueve/adjunta en orden
      }
    }

    // Grid (sin Flickity): ocultar por CSS (tras reatachar todas las celdas).
    function filterCSS(containerEl, master, keep) {
      ensureAttached(containerEl, master);
      master.forEach(function (el) { el.classList.toggle(HIDDEN, !keep(el)); });
    }

    function syncOne(containerEl, master) {
      var has = hasColor(currentColor);
      var keep = keepFn(currentColor, has);
      // Si Flickity está activo -> manejar como carrusel.
      if (filterFlickity(containerEl, master, keep)) return;
      // Si la clase dice "enabled" pero aún no hay instancia, el observer
      // volverá a sincronizar cuando esté lista; no ocultamos por CSS todavía.
      if (isEnabled(containerEl)) return;
      // Grid real (o pre-carrusel): ocultar por CSS. El observer corregirá
      // al activarse Flickity (quita esas celdas y limpia el display:none).
      filterCSS(containerEl, master, keep);
    }

    // Guard de re-entrada: nunca correr dos syncs a la vez (el remove/insert
    // sobre instancias asNavFor se corrompe si se solapan).
    var syncing = false;
    function sync() {
      if (syncing) return;
      syncing = true;
      try {
        syncOne(slider, mainMaster);
        if (navMaster.length) syncOne(thumbsWrap, navMaster);
      } finally {
        syncing = false;
      }
    }

    // Un solo sync por ráfaga de cambios (debounce). Evita correr remove/insert
    // muchas veces por cambio de color, que es lo que descuadraba el carrusel.
    var syncTimer = null;
    function scheduleSync(delay) {
      if (syncTimer) clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        syncTimer = null;
        sync();
      }, delay == null ? 120 : delay);
    }

    function applyColor(color) {
      currentColor = color || '';
      scheduleSync();
    }

    // Observa la (des)activación de Flickity (clase flickity-enabled) y
    // re-sincroniza. Cubre imágenes lentas del CDN y cambios de breakpoint,
    // sin depender de tiempos fijos.
    function observe(el) {
      if (!el || !window.MutationObserver) return;
      var wasEnabled = isEnabled(el);
      var obs = new MutationObserver(function () {
        var now = isEnabled(el);
        if (now !== wasEnabled) {
          wasEnabled = now;
          scheduleSync(0);
        }
      });
      obs.observe(el, { attributes: true, attributeFilter: ['class'] });
    }
    observe(slider);
    observe(thumbsWrap);

    // Estado inicial. El observer cubre el caso de Flickity que inicializa
    // tarde (imágenes del CDN); aquí solo un sync inmediato + uno de respaldo.
    sync();
    scheduleSync(400);

    // Cambio de variante (el evento burbujea hasta document).
    var mySection = root.closest ? root.closest('.shopify-section') : null;
    document.addEventListener('theme:variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      if (mySection && e.target && e.target.closest) {
        var evSection = e.target.closest('.shopify-section');
        if (evSection && evSection !== mySection) return;
      }
      // Solo bloquear scroll en desktop grid (no en carrusel).
      if (!flickityOf(slider)) lockScroll(800);
      // applyColor programa UN solo sync (debounced) tras el cambio; así no
      // se corren varios remove/insert seguidos que descuadran el carrusel.
      applyColor(colorMap[v.id] || '');
    });
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-group-media="true"]')
      .forEach(initGallery);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
